import { AlertTriangle, Lock } from 'lucide-react';

/** C1 — shows "unavailable" (403 for branch-restricted users) or the
 *  incomplete-data warning returned as `branch_coverage` by TB / BS / GL. */
export function BranchCoverageNotice({ unavailable, coverage, testid = 'branch-coverage-notice' }) {
  if (unavailable) {
    return (
      <div className="flex items-start gap-2 rounded-xl border border-slate-300 bg-slate-50 p-3 text-sm text-slate-700" data-testid={`${testid}-unavailable`}>
        <Lock size={16} className="mt-0.5 shrink-0" />
        <span>{unavailable}</span>
      </div>
    );
  }
  if (!coverage?.incomplete) return null;
  return (
    <div className="flex items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-800" data-testid={`${testid}-incomplete`}>
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <span>{coverage.message}</span>
    </div>
  );
}

/** 403 detail → message for the notice; other errors return null. */
export const forbiddenDetail = (err) =>
  err?.response?.status === 403 ? (err.response.data?.detail || 'This report is not available for your access level.') : null;

export default BranchCoverageNotice;
